import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { MANAGEMENT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { isLoadingCommonFilters, isSystemBusy } from "@signals"
import SkuGroupTable from "./SkuGroupTable"
import SkuGroupUserTable from "./SkuGroupUserTable"
import SkuGroupDrawer from "./SkuGroupDrawer"
import SkuGroupUsersModal from "./SkuGroupUsersModal"
import SkuGroupUserModal from "./SkuGroupUserModal"
import SkuGroupDetailModal from "./SkuGroupDetailModal"
import { resetManagementSkuGroupCrudsFilters } from "./@signals"


export default function ManagementSkuGroupCrudsPage() {

    useEffect(() => {
        return () => resetManagementSkuGroupCrudsFilters()
    }, [])

    useEffect(() => {
        isLoadingCommonFilters.value = true
    }, [])

    const props = {
        head: `DIP Insight | ${MANAGEMENT_ROUTES.SKU_GROUP_CRUDS_TITLE}`,
        title: MANAGEMENT_ROUTES.SKU_GROUP_CRUDS_TITLE,
        isEmpty: false,
        actions: null,
        hasErrors: isSystemBusy.value
    }

    return <PageWrapper {...props}>
        <Grid container spacing={2}>

            <Grid item xs={12}>
                <SkuGroupTable />
            </Grid>

            <Grid item xs={12}>
                <SkuGroupUserTable />
            </Grid>

            <Grid item xs={12}>
                <SkuGroupDrawer />
            </Grid>

            <SkuGroupUsersModal />
            <SkuGroupUserModal />
            <SkuGroupDetailModal />

        </Grid>
    </PageWrapper>
}
